import React, { useState } from "react"
import ReCAPTCHA from "react-google-recaptcha"
import "./PaymentModal.css"

export default function({ userDetails, setUserDetails, setPage }) {
  const [name, setName] = useState(userDetails.name)
  const [email, setEmail] = useState(userDetails.email)
  const [mobile, setMobile] = useState(userDetails.mobile)
  const [captchaSiteKey, setCaptchaSiteKey] = useState(
    "6LeVlK0ZAAAAAL4v1S9_-LKVMofeoz1xspOm_AHc"
  )
  const [isValidCaptcha, setIsValidCaptcha] = useState(false)

  function changeCaptchaValid(value) {
    setIsValidCaptcha(value)
  }

  function validateAndNext(e) {
    e.preventDefault()
    if (isValidCaptcha) {
      setUserDetails({ name: name, email: email, mobile: mobile })
      setPage(2)
    } else {
      alert("Please Validate Captcha")
    }
  }

  return (
    <div className="container">
      <form onSubmit={e => validateAndNext(e)}>
        <div
          className="row paymentFont pl-1 text-uppercase mt-1 mb-3"
          style={{ fontSize: "36px" }}
        >
          Contact
        </div>
        <div
          className="row paymentFont pl-1"
          style={{ fontSize: "18px", fontWeight: "500" }}
        >
          Full Name :
        </div>
        <div className="row pl-1 mb-2">
          <input
            class="paymentInputs"
            id="name"
            type="text"
            name="name"
            value={name}
            onChange={e => setName(e.target.value)}
          />
        </div>
        <div
          className="row paymentFont pl-1 "
          style={{ fontSize: "18px", fontWeight: "500" }}
        >
          Email Address :
        </div>
        <div className="row pl-1 mb-2">
          <input
            class="paymentInputs"
            type="email"
            value={email}
            name="email"
            onChange={e => setEmail(e.target.value)}
            required
          />
        </div>
        <div
          className="row paymentFont pl-1"
          style={{ fontSize: "18px", fontWeight: "500" }}
        >
          Mobile Number :
        </div>
        <div className="row pl-1 mb-2">
          <input
            class="paymentInputs"
            type="tel"
            value={mobile}
            name="mobile"
            onChange={e => setMobile(e.target.value)}
            maxLength="10"
            required
          />
        </div>
        <ReCAPTCHA sitekey={captchaSiteKey} onChange={changeCaptchaValid} />
        <button id="payclick" type="submit" hidden />
      </form>
    </div>
  )
}
